import { ColDef } from 'ag-grid-community';
import { useTranslation } from 'react-i18next';

import { FolderIcon } from '@/shared/assets/icons/folder-icon';
import { CONTEXT_MENU_CELL_ID } from '@/shared/components/ui/data-table/components/ag-grid-table-core/ag-grid-table-core.constants';
import { getDateComparator } from '@/shared/components/ui/data-table/data-table.comparator';
import {
  CreatedByRenderer,
  createNameRenderer,
  TimestampRenderer,
} from '@/shared/components/ui/data-table/data-table.renderer';
import { TGroupListActionsRenderer } from '@/shared/features/groups/context/groups-config-context.types';

const COLUMN_WIDTHS = {
  name: { min: 300, default: 300 },
  createdAt: { min: 120 },
  createdBy: { min: 120 },
  contextMenu: { fixed: 150 },
} as const;

const createBaseColumns = (t: (key: string) => string) => ({
  name: (): ColDef => ({
    field: 'name',
    headerName: t('common:name'),
    cellRenderer: createNameRenderer(FolderIcon),
    sortable: true,
    minWidth: COLUMN_WIDTHS.name.min,
    width: COLUMN_WIDTHS.name.default,
  }),
  createdAt: (): ColDef => ({
    field: 'createdAt',
    headerName: t('common:created_at'),
    cellRenderer: TimestampRenderer,
    sortable: true,
    minWidth: COLUMN_WIDTHS.createdAt.min,
    comparator: getDateComparator(),
  }),
  createdBy: (): ColDef => ({
    field: 'createdBy',
    headerName: t('common:created_by'),
    cellRenderer: CreatedByRenderer,
    sortable: false,
    minWidth: COLUMN_WIDTHS.createdBy.min,
  }),
});

export const useSubgroupListDefinitions = (options?: {
  contextMenuRenderer?: TGroupListActionsRenderer;
}): ColDef[] => {
  const { t } = useTranslation();
  const { contextMenuRenderer } = options ?? {};

  const base = createBaseColumns(t);
  const columns: ColDef[] = [base.name(), base.createdAt(), base.createdBy()];

  if (contextMenuRenderer) {
    columns.push({
      field: CONTEXT_MENU_CELL_ID,
      headerName: '',
      cellRenderer: contextMenuRenderer,
      sortable: false,
      minWidth: COLUMN_WIDTHS.contextMenu.fixed,
      width: COLUMN_WIDTHS.contextMenu.fixed,
    });
  }

  return columns;
};
